
lmApp
  .directive('lmCatchupPlayer', ['$rootScope', '$timeout', 'CatchupService',
    function ($rootScope, $timeout, CatchupService) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          event: '=',
          preview: '=',
          references: '=',
          playerData: '=?',
          correction: '=?'
        },
        link: function (scope, element, attrs) {
          scope.permissions = {
            allow: $rootScope.permissions.allow
          };
          scope._player_ = element.find('video#catchup_player');
          scope._frame_ = element.find('img#frame_image');
          scope._frame_.css({height: scope._player_.height()});
          scope._player_.on('resize', function () {
            scope._frame_.css({height: scope._player_.height()});
          });

          scope.player = scope._player_[0];

          scope.player.volume = 0.15;

          scope._CSS = {
            progressPrefix: {
              width: 0
            },
            progressPostfix: {
              width: 0
            },
            progressPlayed: {
              width: 0
            },
            progressBuffer: {
              width: 0
            },
            progressHr: {
              left: 0,
              'padding-top': '.2em'
            },
            progressDetect: {
              left: 0,
              'padding-top': '.2em'
            }
          };

          scope.playerData = {};
          scope.thumbnailGridWidth = 0;

          var toHHMMSS = function (input) {
            var sec_num = Math.abs(parseInt(input, 10));
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours < 10) {
              hours = '0' + hours;
            }
            if (minutes < 10) {
              minutes = '0' + minutes;
            }
            if (seconds < 10) {
              seconds = '0' + seconds;
            }

            return (input < 0 ? '-' : '') + hours + ':' + minutes + ':' + seconds;
          };

          var _onCanPlay = function () {
            scope._playerReady = true;
            $timeout(function () {
              scope._progress_ = element.find('.catchup-player-navigation-progress');
            }, 350);
          };

          var _onLoadStart = function () {
            scope._playerReady = false;
          };

          var _onSeeking = function () {
            scope._playerSeeking = true;
          };

          var _onSeeked = function () {
            scope._playerSeeking = false;
          };

          var _onTimeUpdate = function () {
            if (!scope.total) return;

            $timeout(function () {
              scope._CSS.progressPlayed.width = scope.player.currentTime / scope.total * 100 + '%';
              scope.playerData.position = parseInt(scope.player.currentTime, 10);
              scope.playerData.time = toHHMMSS(scope.player.currentTime + scope.preview.window.from);
            }, 100);
          };

          var _onProgress = function () {
            if (!scope.total) return;

            $timeout(function () {
              if (scope.player.buffered.length) scope._CSS.progressBuffer.width = scope.player.buffered.end(scope.player.buffered.length - 1) / scope.total * 100 + '%';
            }, 100);
          };

          var _onVolumeChange = function () {
            scope.isMuted = scope.player.muted;
          };

          var _onPlay = function () {
            scope.isPlaing = true;
          };

          var _onPause = function () {
            scope.isPlaing = false;
          };

          var _onDurationChange = function () {
            if (!scope.preview) return;
            scope.total = scope.preview.window.to + scope.preview.window.from * (-1);

            $timeout(function () {
              scope._CSS.progressPrefix.width = (-1) * scope.preview.window.from * 100 / scope.total + '%';
              scope._CSS.progressPostfix.width = scope.preview.window.to * 100 / scope.total + '%';
              scope._CSS.progressHr.left = parseInt((-1) * scope.preview.window.from * 100 / scope.total, 10) + '%';
              scope._CSS.progressDetect.left = parseInt(((-1) * scope.preview.window.from + scope.correction) * 100 / scope.total, 10) + '%';
              if (!scope.correction) scope._CSS.progressDetect.display = 'none';
              scope.player.currentTime = Math.abs(scope.preview.window.from);
            }, 100);
          };

          scope.isReady = function () {
            return scope._playerReady;
          };

          scope.previewWatcher = scope.$watchCollection('preview', function (newValue, oldValue) {
            if (!_.isEmpty(newValue) && newValue._media) {
              if ((!oldValue && newValue._media) || newValue._media !== oldValue._media) scope.player.src = newValue._media;

              scope._window = {
                from: parseInt(newValue.window.from / 60, 10),
                to: parseInt(newValue.window.to / 60, 10)
              };
            }
          });

           scope.correctionWatcher = scope.$watch('correction', function (newValue, oldValue) {
            if (newValue !== oldValue && scope.preview) {
              scope._CSS.progressDetect.left = parseInt(((-1) * scope.preview.window.from + newValue) * 100 / scope.total, 10) + '%';
              if (newValue) {
                scope._CSS.progressDetect.display = 'block';
              } else {
                scope._CSS.progressDetect.display = 'none';
              }
            }
          });

          scope.play = function () {
            if (scope.isPlaing) {
              scope.player.pause();
            } else {
              scope.player.play();
            }
          };

          scope.seek = function (event) {
            if (event) {
              scope.player.currentTime = event.offsetX / scope._progress_.width() * scope.total;
            }
          };

          scope.jump = function (value, event) {
            if (event && event.stopPropagation) event.stopPropagation();
            if (event && event.preventDefault) event.preventDefault();
            if (scope.player.currentTime + value < 0) return;

            if (scope.isPlaing) scope.player.pause();
            scope.player.currentTime += parseInt(value, 10);
          };

          scope.toggleMute = function () {
            scope.player.muted = !scope.player.muted;
          };

          var onImgLoad = function () {
            $timeout(function () {
              scope.loadingFrame = false;
              scope.loading = false;
              $rootScope.hideLinearProgress('#catchupLoader' + scope.event.id);
            }, 100);
            scope._frame_.unbind('load', onImgLoad);
          };

          scope.getIt = function (event) {
            if (scope.isPlaing) scope.player.pause();

            scope.loadingFrame = true;
            scope.loading = true;
            $rootScope.showLinearProgress('#catchupLoader' + event.id);

            scope._frame_.bind('load', onImgLoad);

            scope.preview._frame = '';
            $timeout(function () {
              scope.preview._frame = CatchupService.GetCatchup2ReferenceFromMedia(event, scope.preview, scope.player.currentTime || 0);
            }, 100)
          };

          scope.createPreview = function (event) {
            scope.loading = true;
            $rootScope.showLinearProgress('#catchupLoader' + event.id);

            CatchupService.CreateCatchup2Preview(event)
              .then(function (result) {
                scope.loading = false;
                $rootScope.hideLinearProgress('#catchupLoader' + event.id);

                event._PrivateData.catchup2.preview = result.preview;

                scope.$parent._checkPreviewInterval(event);
              })
              .catch(function (reason) {
                scope.loading = false;
                $rootScope.hideLinearProgress('#catchupLoader' + event.id);

                $rootScope.debugInfo(reason);
              });
          };

          scope.setReferenceImg = function (event) {
            if (scope.loadingFrame) return;

            scope.loadingFrame = true;
            $rootScope.showLinearProgress('#catchupLoader' + event.id);

            CatchupService.SetCatchup2References(event, scope.preview._frame.replace(
              '/discovery:80', window.protocol + ':\/\/' + 'admin-ams.sotalcloud.com/discovery:80'
              //'/discovery:80', window.protocol + ':\/\/' + window.hostname
            ))
              .then(function (result) {
                scope.loadingFrame = false;
                $rootScope.hideLinearProgress('#catchupLoader' + event.id);

                result.reference._url = CatchupService.GetCatchup2ReferenceImg(event, result.reference);
                event._PrivateData.catchup2.references.push(result.reference);
              }).catch(function (reason) {
                scope.loadingFrame = false;

                $rootScope.hideLinearProgress('#catchupLoader' + event.id);
                $rootScope.debugInfo(reason);
              });
          };

          var index = 0;
          var position = 0;
          var thumbnailPosition = {
            x:0,
            y:0
          };
          var invisibleImg;
          scope.seekTime = function (event) {
            if (event) {
              position = parseInt(event.offsetX, 10) / parseInt(scope._progress_.width(), 10) * scope.total;
              scope.playerData.overTime = toHHMMSS(position + scope.preview.window.from);

              scope.playerData.thumbnail = CatchupService.GetCatchup2ThumbnailImg(scope.event, scope.preview, index);

              if (!invisibleImg) {
                invisibleImg = angular.element('<img>');
                invisibleImg[0].src = scope.playerData.thumbnail;
                invisibleImg.css({
                  visibility: 'hidden',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  'z-index': -1000
                });

                invisibleImg.appendTo('body');

                invisibleImg.one('load', function () {
                  scope.thumbnailGridWidth = this.width / 10;
                });

                element.on('$destroy', function () {
                  invisibleImg.remove();
                });
              }

              thumbnailPosition.x = Math.floor((position % 100) / 10) * scope.thumbnailGridWidth;
              thumbnailPosition.y = Math.floor(position / 100) * 45;

              scope._CSS.tumbnail = {
                height: '45px',
                'background-image': 'url("' + scope.playerData.thumbnail + '")',
                'background-position': '-' + (Math.floor((position % 100) / 10) * scope.thumbnailGridWidth) + 'px ' + '-' + (Math.floor(position / 100) * 45) + 'px'
              };
            }
          };

          scope._player_.bind('loadstart', _onLoadStart);
          scope._player_.bind('seeking', _onSeeking);
          scope._player_.bind('seeked', _onSeeked);
          scope._player_.bind('canplay', _onCanPlay);
          scope._player_.bind('durationchange', _onDurationChange);
          scope._player_.bind('timeupdate', _onTimeUpdate);
          scope._player_.bind('progress', _onProgress);
          scope._player_.bind('play', _onPlay);
          scope._player_.bind('pause', _onPause);
          scope._player_.bind('volumechange', _onVolumeChange);

          element.on('$destroy', function () {
            if (scope.previewWatcher) scope.previewWatcher();
            if (scope.correctionWatcher) scope.correctionWatcher();
            scope._player_.remove();
            scope._player_.unbind('loadstart', _onLoadStart);
            scope._player_.unbind('seeking', _onSeeking);
            scope._player_.unbind('seeked', _onSeeked);
            scope._player_.unbind('canplay', _onCanPlay);
            scope._player_.unbind('durationchange', _onDurationChange);
            scope._player_.unbind('timeupdate', _onTimeUpdate);
            scope._player_.unbind('progress', _onProgress);
            scope._player_.unbind('play', _onPlay);
            scope._player_.unbind('pause', _onPause);
            scope._player_.unbind('volumechange', _onVolumeChange);
          });


          scope.toggleMute();
        },
        templateUrl: 'lm-catchup-player/lm-catchup-player.tpl.html'
      }
    }
  ]);
